<template>
  <div>
    <div class="account-user rounded-circle text-uppercase d-flex align-items-center justify-content-center">
      <span>{{ initials }}</span>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li class="px-3 py-2 border-bottom">
        <div class="fw-bold">{{ userEmail || 'Usuario' }}</div>
      </li>
      <li>
        <router-link to="/dashboard/mi-perfil" class="dropdown-item d-flex align-items-center gap-2">
          <vue-feather type="user" size="16" />
          <span>Mi Perfil</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/cambiar-contraseña" class="dropdown-item d-flex align-items-center gap-2">
          <vue-feather type="settings" size="16" />
          <span>Configuración</span>
        </router-link>
      </li>
      <li>
        <a href="#" class="dropdown-item d-flex align-items-center gap-2" @click.prevent="logout">
          <vue-feather type="log-out" size="16" />
          <span>Cerrar Sesión</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getSessionUser } from "@/services/api";

export default {
  name: "ProfileView",
  computed: {
    userEmail() {
      return this.$store.state.autenticacion?.usuarioActual?.email || getSessionUser()?.email || "";
    },
    initials() {
      const email = this.userEmail;
      if (!email) return "US";
      const namePart = email.split("@")[0] || "";
      if (!namePart) return "US";
      const parts = namePart.split(/[.\-_ ]+/).filter(Boolean);
      if (!parts.length) return namePart.slice(0, 2).toUpperCase();
      const first = parts[0][0] || "";
      const second = (parts[1] && parts[1][0]) || "";
      return (first + second).toUpperCase();
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch("autenticacion/cerrarSesion");
      this.$router.replace("/auth/login");
    },
  },
};
</script>

